import { render } from "./App.vue?vue&type=template&id=618705f4&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=618705f4&lang=scss&scoped=true"

import exportComponent from "D:\\alive\\study\\pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618705f4"]])

export default __exports__